import styles from './InfoBox.module.scss'
import { Space } from '../Space/Space'
import { ReactComponent as AlertIcon } from '@tradera/blueprint/theme/icons2/alert.svg'
import { ReactComponent as CheckIcon } from '@tradera/blueprint/theme/icons2/check-fill.svg'
import { ReactComponent as InfoIcon } from '../../Icons/info.svg'
import classNames from 'classnames'

type InfoBoxProps = React.PropsWithChildren<{
  title?: string
  className?: string
  /**
   * Default is info
   */
  theme?: 'info' | 'danger' | 'success'
  /**
   * Default is info
   */
  icon?: 'info' | 'check' | 'success' | 'alert'
  info?: boolean
  check?: boolean
  success?: boolean
  alert?: boolean
  loading?: boolean
  danger?: boolean
  actions?: React.ReactNode | React.ReactNode[]
  children?: React.ReactNode
}>

export const InfoBox = ({
  title,
  className,
  icon,
  actions,
  children,
  theme,
}: InfoBoxProps) => {
  let Icon = InfoIcon
  if (icon === 'check' || icon === 'success') Icon = CheckIcon
  else if (icon === 'alert') Icon = AlertIcon

  return (
    <Space
      justify="between"
      className={classNames(
        styles.infoBox,
        {
          [styles.danger]: theme === 'danger',
          [styles.success]: theme === 'success',
        },
        className
      )}
      role="alert"
    >
      <Space
        direction={title ? 'vertical' : 'horizontal'}
        align="start"
        gap={title && children ? 1 : children ? 2 : 0}
      >
        <Space gap={1}>
          <Icon className="icon icon-md flex-shrink-0 icon-gray-800" />
          {title ? (
            <h4 className="amsterdam font-weight-normal font-hansen m-0">
              {title}
            </h4>
          ) : null}
        </Space>
        <Space direction="vertical" gap={2}>
          {children ? <p className="font-gray-700">{children}</p> : null}
          {actions && <Space gap={1}>{actions}</Space>}
        </Space>
      </Space>
    </Space>
  )
}
